import { render, staticRenderFns } from "./ContactEditor.vue?vue&type=template&id=7b52f704&scoped=true"
import script from "./ContactEditor.vue?vue&type=script&lang=js"
export * from "./ContactEditor.vue?vue&type=script&lang=js"
import style0 from "./ContactEditor.vue?vue&type=style&index=0&id=7b52f704&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b52f704",
  null
  
)

export default component.exports